import React from 'react';

const Footer = () => {
    return (
        <div id="Copyright">
            <p>© Théo Guénézan</p>
        </div>
    );
}

export default Footer;
